import { render, staticRenderFns } from "./BoardFilterFaqLayout.vue?vue&type=template&id=5268761a&scoped=true&"
import script from "./BoardFilterFaqLayout.vue?vue&type=script&lang=js&"
export * from "./BoardFilterFaqLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5268761a",
  null
  
)

export default component.exports